// extracted by mini-css-extract-plugin
module.exports = {"button":"RetexAction_button__1BO9K","alertModal":"RetexAction_alertModal__1WUZe","alertDescription":"RetexAction_alertDescription__3NMdy"};